import {
  getShowDescriptionPlace,
  isInAccessibilityMode,
  isInDescription,
  isInMobileBasket,
} from '../../../../selectors/seating/mode'
import {getPlacesInBasket, getSelectedPlace} from '../../../../selectors/seating/places'
import {getSelectedTicketsQuantity} from '../../../../selectors/selected-tickets'
import {DetailsPageAppProps} from '../../../app/interfaces'
import {connect} from '../../../runtime-context/context'
import {MobileOwnProps, MobileRuntimeProps} from './interfaces'
import {Mobile as Presentation} from './mobile'

const mapRuntime = ({state, actions: {setShowMobileBasket}}: DetailsPageAppProps): MobileRuntimeProps => {
  const placesInBasket = getPlacesInBasket(state)

  return {
    showAccessibilityMode: isInAccessibilityMode(state),
    selectedPlace: getSelectedPlace(state),
    showDescription: isInDescription(state),
    descriptionPlace: getShowDescriptionPlace(state),
    placesInBasketCount: getSelectedTicketsQuantity(state),
    placesInBasket,
    showMobileBasket: isInMobileBasket(state),
    setShowMobileBasket,
  }
}

export const Mobile = connect<MobileOwnProps, MobileRuntimeProps>(mapRuntime)(Presentation)
export * from './interfaces'
